<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
      { title: this.$t(`menu.${serviceSlug}`), disabled: true},
      {title: this.$t('menu.evohealth/anamneses'), active: true, meta: {type: 'string', value: `/${this.serviceSlug}/${this.serviceSlug}/anamneses`}},
      { title: data.title ? data.title : 'Nova Anamnese', disabled: true}
    ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">

      </div>
    </Breadcrumbs>

    <template v-if="isLoading">
      <div class="overlay-loader"></div>
      <LoadingPlaceholder />
    </template>
    <div v-else>
      <div class="evollu-form mt-3 outline-border">
        <div class="col-12">
          <va-input
            :placeholder="$t('users.inputs.title')"
            v-model="data.title"
            id="anamnese_title"
            :maxlength="255"
            :label="$t('users.inputs.title')"
            required
          />
        </div>


        <div class="p-3 mt-3">
          <label class="">Questões</label>

          <div v-for="(question, idx) in data.questions">
            <div class="outline-border">
              <div class="row justify--space-between ml-3 mr-3" style="margin-bottom: 5px !important">
                <h4 class=""> {{ $t('evohealth.anamneses.question') }} {{ idx + 1 }} </h4>
                <div class="d-flex flex-row">
                  <va-popover
                    v-if="!question.hasAnswers"
                    placement="left"
                    :message="$t('agenda.appointments.delete')"
                  >
                    <i class="fa fa-trash pt-2" style="color:darkred" @click="handleRemoveQuestion(idx)"/>
                  </va-popover>
                  <div class="col-2 d-flex flex-column pl-3">
                    <i class="fa fa-caret-up" v-bind:class="{'clickable': idx !== 0, 'sort-icon-disabled': idx === 0}" @click="idx !== 0 ? handleQuestionSort('up', question) : null"/>
                    <i class="fa fa-caret-down" v-bind:class="{'clickable': idx !== data.questions.length-1, 'sort-icon-disabled': idx === data.questions.length-1}" @click=" idx !== data.questions.length-1 ? handleQuestionSort('down', question) : null"/>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <va-input
                  :placeholder="$t('users.inputs.title')"
                  v-model="question.question"
                  id="anamnese_creating_question"
                  :maxlength="255"
                  :label="$t('users.inputs.title')"
                  required
                />
              </div>
              <div class="p-4">
                <label class="">Opções de Resposta</label>
                <div class="outline-border">
                  <div v-for="(answer, idxAnswer) in question.answerOptions" style="margin-bottom: 15px">
                    <div class="row justify--space-between ml-3 mr-3" style="margin-bottom: 5px !important">
                      <h5 class="ml-2"> {{ $t('evohealth.anamneses.answer_option') }} {{ idxAnswer + 1 }} </h5>
                      <div class="d-flex flex-row">
                        <div v-if="!question.hasAnswers">
                          <va-popover
                            placement="left"
                            :message="$t('agenda.appointments.delete')"
                          >
                            <i class="fa fa-trash pt-2" style="color:darkred" @click="handleRemoveAnswerOption(question, idxAnswer)"/>
                          </va-popover>
                        </div>
                        <div class="col-2 d-flex flex-column pl-3">
                          <i class="fa fa-caret-up" v-bind:class="{'clickable': idxAnswer !== 0, 'sort-icon-disabled': idxAnswer === 0}" @click="idxAnswer !== 0 ? handleAnswerOptionSort('up', question, answer) : null"/>
                          <i class="fa fa-caret-down" v-bind:class="{'clickable': idxAnswer !== question.answerOptions.length-1, 'sort-icon-disabled': idxAnswer === question.answerOptions.length-1}" @click=" idxAnswer !== question.answerOptions.length-1 ? handleAnswerOptionSort('down', question, answer) : null"/>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <va-input
                        :placeholder="$t('users.inputs.title')"
                        v-model="answer.optionText"
                        id="anamnese_creating_question"
                        :maxlength="255"
                        :label="$t('users.inputs.title')"
                        required
                      />
                    </div>
                  </div>
                  <div v-if="question.answerOptions.length === 0" class="ml-2">
                    <span>{{ $t('evohealth.anamneses.no_answer_option') }}</span>
                  </div>

                  <div class="row justify--end mr-2 mt-2">
                    <va-button
                      id="btn-add-question"
                      @click="handleAddNewQuestionAnswerOption(question)">
                      {{ $t('evohealth.anamneses.add_answer_option') }}
                    </va-button>
                  </div>
                </div>
              </div>

            </div>

          </div>
          <div v-if="data.questions.length === 0">
            <span> {{ $t('evohealth.anamneses.no_question') }}</span>
          </div>



          <div class="row justify--end mt-2">
            <va-button
              id="btn-add-question"
              @click="handleAddNewQuestion">
              {{ $t('evohealth.anamneses.add_question') }}
            </va-button>
          </div>
        </div>

      </div>

      <div class="row justify--end mr-3">
        <va-button :disabled="saveDisabled" @click.prevent="handleSubmit">{{this.$t('agenda.availability.save')}}</va-button>
      </div>
    </div>


  </div>


</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs.vue';
import LoadingPlaceholder from '@/components/common/LoadingPlaceholder.vue';
import { EvohealthService } from '@/api/EvohealthService';

export default {
  components: { LoadingPlaceholder, Breadcrumbs },
  props: {
    serviceSlug: {
      type: String,
      required: true,
    },
    component: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: {
        id: null,
        entityId: null,
        title: null,
        creatingQuestionText: null,
        creatingAnswerText: null,
        questions: [],
      },
      isLoading: false,
      selectedEntity: null
    };
  },
  async created() {
    if (this.$route.params && this.$route.params.type && this.$route.params.type === 'update') {
      await this.gatherAnamnese()
    } else if (this.$route.params && this.$route.params.type && this.$route.params.type === 'create' && this.$route.params.entity) {
      this.selectedEntity = this.$route.params.entity

      if(this.selectedEntity === null) {
        this.$router.replace(`/evohealth/evohealth/anamneses`)
        setTimeout(() => {
          this.showToast("Erro: Nenhuma entidade selecionada", this.$store.state.errorToastOptions)
        }, 500)
      }
    }

    //console.log(this.data)

  },
  methods: {
    handleQuestionSort: function(direction, question) {
      const currentElemIdx = this.data.questions.findIndex(item => item === question)
      const currentElemOrderTemp = question.order

      if(direction === 'down') {
        const nextElemOrderTemp = this.data.questions[currentElemIdx+1].order
        this.data.questions[currentElemIdx].order = nextElemOrderTemp
        this.data.questions[currentElemIdx+1].order = currentElemOrderTemp
      } else if (direction === 'up') {
        const nextElemOrderTemp = this.data.questions[currentElemIdx-1].order
        this.data.questions[currentElemIdx].order = nextElemOrderTemp
        this.data.questions[currentElemIdx-1].order = currentElemOrderTemp
      }

      this.data.questions = this.data.questions.sort((a, b) => (a.order > b.order) ? 1 : -1)
    },
    handleAnswerOptionSort: function(direction, question, answerOption) {
      const currentElemIdx = question.answerOptions.findIndex(item => item === answerOption)
      const currentElemOrderTemp = answerOption.order

      if(direction === 'down') {
        const nextElemOrderTemp = question.answerOptions[currentElemIdx+1].order
        question.answerOptions[currentElemIdx].order = nextElemOrderTemp
        question.answerOptions[currentElemIdx+1].order = currentElemOrderTemp
      } else if (direction === 'up') {
        const nextElemOrderTemp = question.answerOptions[currentElemIdx-1].order
        question.answerOptions[currentElemIdx].order = nextElemOrderTemp
        question.answerOptions[currentElemIdx-1].order = currentElemOrderTemp
      }

      question.answerOptions = question.answerOptions.sort((a, b) => (a.order > b.order) ? 1 : -1)
    },
    gatherAnamnese: async function(id) {
      //Get details
      this.isLoading = true
      const anamnese = await EvohealthService.getAnamneseDetails(id ? id : this.$route.params.id)
      this.isLoading = false

      if(anamnese) {
        this.data.id = parseInt(anamnese.id)
        this.data.title = anamnese.name
        this.data.questions = anamnese.questions
        this.data.entityId = parseInt(anamnese.entityId)
      }
    },
    handleAddNewQuestion: function(idx) {
      //We should first see if all added questions are filled and have answerOptions before proceed
      if (this.data.questions.some(q => q.question === null || q.question === '' || q.answerOptions.length === 0)) return;
      this.data.questions.push({
        question: null,
        answerOptions: [],
        order: this.data.questions.length
      });
    },
    handleAddNewQuestionAnswerOption: function(question) {
      if (question.answerOptions.some(a => a.text === null || a.text === '')) return;
      question.answerOptions.push({
        optionText: null,
        order: question.answerOptions.length || 0
      });
    },
    handleRemoveQuestion: function(index) {
      this.data.questions.splice(index, 1)
      //Decrese 1 order to every question after the removed one
      this.data.questions.forEach((q, idx) => {
        if(idx >= index) {
          q.order = q.order - 1
        }
      })
    },
    handleRemoveAnswerOption: function(question, idx) {
      question.answerOptions.splice(idx, 1)
      //Decrease 1 order to every answer Option after the removed one
      question.answerOptions.forEach((ao, idx) => {
        if(idx >= idx) {
          ao.order = ao.order - 1
        }
      })
    },
    handleSubmit: async function() {
      const data = {}
      if(this.data.id) {
        data.id = this.data.id
      }
      data.entityId = this.selectedEntity ? this.selectedEntity.id : this.data.entityId
      data.name = this.data.title
      data.questions = this.data.questions

      try {
        const response = await EvohealthService.createAnamnese(data)
        await this.gatherAnamnese(response.id)
        this.showToast(this.$t('evohealth.anamneses.anamnese_saved_success'), this.$store.state.successToastOptions)
      } catch (e) {
        console.log(e)
        this.showToast(this.$t('auth.tfa.errors.generic'), this.$store.state.errorToastOptions)
      }
    }
  },
  computed: {
    saveDisabled: function() {
      if(this.data.title === '' || this.data.title === null) return true

      if(this.data.questions === null || this.data.questions.length === 0) return true

      if(this.data.questions.length > 0 && this.data.questions.some(q => q.question === null || q.question === '')) return true

      if( this.data.questions.some(q => q.answerOptions.length === 0 || q.answerOptions.some(ao => ao.optionText === null || ao.optionText === ''))) return true


      return false
    }
  }
};
</script>

<style scoped lang="scss">
.sort-icon-disabled {
  opacity: 0.2;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7); /* Semi-transparent white background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999; /* Ensure it appears above the table */
}

.no-data-disclaimer {
  width: 100%;
  margin-top: 20px;
  border-radius: 12px;
  background-color: rgb(246, 236, 221);
  height: 60px;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;

  h5 {
    color: #878787;
  }
}

.outline-border {
  border: 1px solid #dadada;
  border-radius: 15px;
  padding-top: 10px;
  padding-bottom: 20px;
}

.outline-border-answer-options {
  border: 1px solid #dadada;
  border-radius: 15px;
  padding-top: 10px;
  padding-bottom: 20px;
  margin-left: 15px;
  margin-right: 15px;
}

.outline-border {
  margin-bottom: 15px;
}

</style>
